import { memo, useCallback, useEffect, useRef, useState } from "react"
import ListUi from "./ListUi"
import { useDispatch } from 'react-redux'
import { callApiAction } from "../../store/actions/commonAction"

import { closeModal, openModal } from "../../store/actions/modalAction"

import { Box, Button, Chip, CircularProgress, ClickAwayListener, Grow, IconButton, MenuItem, MenuList, Paper, Popper, Switch, Tooltip, Typography } from "@mui/material"
import { useMemo } from "react"
import CreateController from "./CreateController"
import { Check, Delete, Download, Edit, Info, KeyboardArrowRight, MoreVert } from "@mui/icons-material"

import { AllZipOscillaAudiogramApi, deleteBeneficiaryApi, getBeneficiaryApi, validateBeneficiaryApi } from "../../apis/beneficiary.api"
import moment from "moment"
import DetailedViewController from "./detailedview/DetailedViewController"
import { BENIFICIARY_STATUS } from "../../utils/beneficiary.constant"

import { createFullName, findObjectKeyByValue } from "../../utils/helper"
import BeneficiaryUpdateButton from "./components/BeneficiaryUpdateButton"
import BeneficiaryTestButton from "./components/BeneficiaryTestButton"
import fileDownload from "js-file-download"
// import UpdateHearingTestDetailsController from "./UpdateHearingTestDetailsController"
import MessageDilog from "../../components/MessageDilog"
import { useNavigate } from "react-router-dom"
import { callSnackBar } from "../../store/actions/snackbarAction"
import { downloadAudiogramApi } from "../../apis/oscilla.api"
import { SNACK_BAR_VARIETNS } from "../../utils/constants"

export const BeneficiaryActionComponent = memo(({ params, setParams, modalKey, filters }) => {
    const dispatch = useDispatch()
    const anchorRef = useRef(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [open, setOpen] = useState(false)

    const [loading, setLoading] = useState(false)

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    const onViewMore = () => {
        dispatch(openModal(<DetailedViewController
            id={params._id}

        />, "md", false, "beneficiary-detailed-view"))
    }

    useEffect(() => {
        if (modalOpen) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [modalOpen]);
    const navigate = useNavigate();
    const onViewMores = () => {
        navigate(`/beneficiary/${params._id}`, { state: { patientData: params } });
    };

    const [downloadLoading, setDownloadLoading] = useState(false);

    const onDownloadClick = (params) => {
        setDownloadLoading(true);
        dispatch(
            callApiAction(
                async () => {
                    const response = await downloadAudiogramApi({ id: params?._id });
                    return response;
                },
                (response) => {
                    let pdfBlob =
                        response instanceof Blob
                            ? response
                            : new Blob([response], { type: "application/pdf" });
                    const reader = new FileReader();
                    reader.onloadend = () => { };
                    reader.readAsText(pdfBlob);
                    fileDownload(
                        pdfBlob,
                        `${params?.first_name} ${params?.last_name}'s audiogram.pdf`
                    );
                    setDownloadLoading(false);
                },
                (err) => {
                    dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error));
                    setDownloadLoading(false);
                },
                true
            )
        );
    };

    return <Box sx={{ width: "100%", display: "flex" }}>


        <IconButton fullWidth color="info" disableElevation size="inherit" onClick={onViewMore}>
            <Info />
        </IconButton>
        <IconButton
            onClick={async (e) => await onDownloadClick(params)}
            sx={{ padding: 0, ml: 2 }}
        >
            <Tooltip title="Download Audiogram">
                {!downloadLoading ? (
                    <Download sx={{ color: "#2D3B67" }} />
                ) : (
                    <CircularProgress color="primary" size="25px" />
                )}
            </Tooltip>
        </IconButton>
        {/* <IconButton
            ref={anchorRef}
            id="composition-button"
            aria-controls={open ? 'composition-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
        >
            <MoreVert />
        </IconButton> */}

        <IconButton size="inherit" onClick={onViewMores}>
            <KeyboardArrowRight fontSize="inherit" />
        </IconButton>

        <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="right-start"
            transition
            disablePortal
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin:
                            placement === 'bottom-start' ? 'left top' : 'right top',
                    }}
                >
                    <Paper>
                        <ClickAwayListener onClickAway={handleClose}>
                            <MenuList
                                autoFocusItem={open}
                                id="composition-menu"
                                aria-labelledby="composition-button"

                            >
                                <BeneficiaryUpdateButton
                                    id={params._id}
                                    status={params.status}
                                    type="menuitem"
                                />
                                <BeneficiaryTestButton
                                    id={params._id}
                                    status={params.status}
                                    params={params}
                                    setParams={setParams}
                                />
                                {/* <MenuItem onClick={onViewMore}>
                                    View Details
                                </MenuItem> */}

                            </MenuList>
                        </ClickAwayListener>
                    </Paper>
                </Grow>
            )}
        </Popper>


    </Box>
})

const DeleteBeneficiaryButton = memo(({ params, setParams, modalKey }) => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)


    const onSubmit = (e) => {
        e.preventDefault()
        dispatch(closeModal())
        setLoading(true)
        dispatch(callApiAction(
            async () => await deleteBeneficiaryApi({ id: params?._id }),
            (response) => {
                setLoading(false)
                setParams({})
            },
            (err) => {
                setLoading(false)
            }
        ))
    }
    const onClick = () => {
        dispatch(openModal(<MessageDilog

            title={"Are you sure to delete " + params.name}
            message="On click of delete beneficiary will be deleted and also remnoved from camp & event"
            onSubmit={onSubmit}

        />, "sm"))
    }



    if (loading)
        return <CircularProgress />

    return <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>
        {/* 
        <IconButton onClick={onClick} >
            <Delete />
        </IconButton> */}
    </Box>
})

// const UpdateBeneficiaryDetailsComponent = memo(({ params, setParams, modalKey }) => {
//     return <></>
// })

const ListController = ({ defaultFilters = {} }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const title = "Beneficiary Data "
    const modalKey = 'beneficiary'
    const fetchApi = getBeneficiaryApi


    const columns = useMemo(() => [
        { id: 0, fieldName: 'camp_date', label: 'Camp Date', align: "left", sort: true, renderValue: (fields) => fields.camp_date ? moment(fields.camp_date).format("DD/MM/YYYY") : "NA" },
        { id: 2, fieldName: 'createdAt', label: 'Created Date', align: "left", sort: true, renderValue: (fields) => fields.createdAt ? moment(fields.createdAt).format("DD/MM/YYYY") : "NA" },
        { id: 1, fieldName: 'first_name', label: 'Name', align: "left", sort: true, renderValue: (params) => (params.first_name + " " + params.last_name) },
        { id: 3, fieldName: 'phone', label: 'Phone No.', align: "left" },
        { id: 3, fieldName: 'district', label: 'District', align: "left", sort: true, renderValue: (params) => params.district },
        // { id: 8, fieldName: 'status', label: 'Status', align: "left", sort: true, renderValue: (params, setParams) => <Chip size="small" label={findObjectKeyByValue(params.status, BENIFICIARY_STATUS)} /> },
        { id: 7, fieldName: 'action', label: 'Action', align: "left", renderValue: (params, setParams) => <BeneficiaryActionComponent params={params} setParams={setParams} /> },

        // { id: 8, fieldName: 'action', label: 'Action', align: "left", renderValue: (params, setParams) => <DeleteBeneficiaryButton params={params} setParams={setParams} /> },
    ], [dispatch]);


    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: '',
        searchable: ['first_name', 'last_name', 'phone'],
        sort: 'createdAt',
        donation_event_id: null,
        camp: null,
        camp_name:"",
        country: null,
        state: null,
        district: null,
        // status: null,        
        taluka: null,

        udise_file: "",
        photo: "",
        aadhar_file: "",
        income_certi: "",
        sortDirection: -1,
        ...defaultFilters

    })


    // do not change 

    const [loading, setLoading] = useState(false)
    const [exportLoading, setexportLoading] = useState(false)
    const [exportzipLoading, setexportzipLoading] = useState(false)
    const [list, setList] = useState({})

    const fetchList = (isExport) => {
        if (!isExport) {
            setLoading(true)
            dispatch(callApiAction(
                async () => await fetchApi({ ...filters }),
                (response) => {
                    setList(response)
                    setLoading(false)
                },
                (err) => {
                    setLoading(false)
                }
            ))
        } else {
            setexportLoading(true)
            dispatch(callApiAction(
                async () => await fetchApi({ ...filters, csv: true }),
                (response) => {
                    fileDownload(response, "beneficiary.csv")
                    setexportLoading(false)
                },
                (err) => {
                    console.log(err)
                    setexportLoading(false)
                },
                true
            ))
        }
    }

    // const fetchList = (isExport) => {
    //     // setLoading(true)
    //     // dispatch(callApiAction(
    //     //     async () => await fetchApi({ ...filters }),
    //     //     (response) => {
    //     //         setList(response)
    //     //         setLoading(false)
    //     //     },
    //     //     (err) => {
    //     //         setLoading(false)
    //     //     }
    //     // ))

    //     if (!isExport) {
    //         setLoading(true)
    //         dispatch(callApiAction(
    //             async () => await fetchApi({ ...filters }),
    //             (response) => {
    //                 setList(response)
    //                 setLoading(false)
    //             },
    //             (err) => {
    //                 setLoading(false)
    //             }
    //         ))
    //     } else {
    //         setexportLoading(true)
    //         dispatch(callApiAction(
    //             async () => await fetchApi({ ...filters, csv: true }),
    //             (response) => {
    //                 fileDownload(response, "customers.csv")
    //                 setexportLoading(false)
    //             },
    //             (err) => {
    //                 console.log(err)
    //                 setexportLoading(false)
    //             },
    //             true
    //         ))
    //     }
    // }
    const callBackFun = useCallback(({ _id, name, surname }) => {

        fetchList();
    }, [filters])
    const onCreateBtnClick = () => {
        dispatch(openModal(<CreateController callBack={async () => { fetchList() }} />, "sm", false, modalKey))
        // navigate("/add/")
    }

    const onExportBtnClick = () => {
        fetchList(true)
    }

    useEffect(() => {
        fetchList()
    }, [filters])


    const handleDownload = async () => {
        setexportzipLoading(true)
        const success = await AllZipOscillaAudiogramApi({ id: filters?.camp, name: filters?.camp_name });
        if (success) {
            setexportzipLoading(false)
        } else {
            setexportzipLoading(false)
        }
        // dispatch(callApiAction(
        //     async () => await AllZipOscillaAudiogramApi({ id: filters?.camp }),
        //     (response) => {
        //         const blob = new Blob([response.data], { type: "application/zip" });
        //         const url = window.URL.createObjectURL(blob);

        //         const link = document.createElement("a");
        //         link.href = url;
        //         link.setAttribute("download", `camp_${filters?.camp_name}_reports.zip`);
        //         document.body.appendChild(link);
        //         link.click();

        //         link.remove();
        //         window.URL.revokeObjectURL(url);
        //     },
        //     (err) => {
        //         setLoading(false)
        //     }
        // ))
       };

    return (
        <>
            <ListUi
                callBackFun={callBackFun}
                title={title}
                onCreateBtnClick={onCreateBtnClick}
                exportLoading={exportLoading}
                onExportBtnClick={onExportBtnClick}
                filters={filters}
                setFilters={setFilters}
                loading={loading}
                list={list}
                columns={columns}
                handleDownload={handleDownload}
                exportzipLoading={exportzipLoading}
            />

        </>
    )
}
export default ListController